import {
  DEBOUNCE_INTERVAL
} from './const';
import {
  updateBasket
} from './basket';


export function makeInput(typeName, className, val, min, name, id) {
  let element = document.createElement('input');
  element.type = typeName;
  element.classList.add(className);
  if (val) {
    element.value = val;
  }
  if (min) {
    element.min = min;
  }
  if (name) {
    element.name = name;
  }
  if (id) {
    element.id = id;
  }
  return element;
}

export function makeElem(tagName, className, text) {
  let element = document.createElement(tagName);
  element.classList.add(className);
  if (text) {
    element.textContent = text;
  }
  return element;
}

export function replaceBlocksAndUpdateBasket(names, data) {
  const countContainer = data.querySelector('.finish__count');
  if (!countContainer) {
    return;
  }
  let count = data.querySelector('.finish__count').textContent;
  updateBasket(count);
  replaceBlocks(names, data);
}

export function replaceBlocks(names, data) {
  for (const name of names) {
    let blockStatic = document.querySelector(name);
    if (blockStatic) {
      let blockLoaded = data.querySelector(name);
      blockStatic.replaceWith(blockLoaded);
    }
  }
}

export function compareArrays() {
  let arrayDefault = [];
  // eslint-disable-next-line consistent-return
  return function (arrayCurrent) {
    if (arrayCurrent !== undefined) {
      let isSame = arrayDefault.length === arrayCurrent.length && arrayDefault.every((item, i) => item === arrayCurrent[i]);
      if (isSame) {
        return true;
      } else {
        arrayDefault = arrayCurrent;
        return false;
      }
    }
  };
}

export function filterArraysFromForm(arr) {
  return Array.from(arr).filter(onlyVisible).map(onlyValue);

  function onlyVisible(elem) {
    return elem.tagName === 'INPUT' && elem.type !== 'hidden';
  }

  function onlyValue(elem) {
    return elem.value;
  }
}

export function showMessage(text, status) {
  removeMessage();
  let message = createMessage(text, status);
  setTimeout(function () {
    message.remove();
  }, 5000);
}

function removeMessage() {
  let elem = document.querySelector('.message');
  if (elem) {
    elem.remove();
  }
}

function createMessage(text, status = 'error') {
  let message = makeElem('div', 'message', text);
  message.classList.add(`message--${status}`);
  document.body.prepend(message);
  return message;
}

export function logMessage(error) {
  const result = {
    message: error.message,
    stack: error.stack,
    url: window.location.href,
    browser: checkBrowser(),
    bot: String(/bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)),
  };

  const str = JSON.stringify(result);
  fetch(window.origin + '/index.php?option=com_jshopping&controller=errors&task=getJSError&body=' + encodeURIComponent(str));
  window.onload = function () {
    // eslint-disable-next-line no-undef
    ym(39430325, 'reachGoal', 'jsError');
  };
}

function checkBrowser() {
  let agent = navigator.userAgent;
  let tem;
  let M = agent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(agent) || [];
    return 'IE ' + (tem[1] || '');
  }
  if (M[1] === 'Chrome') {
    tem = agent.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem !== null) {
      return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = agent.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return M.join(' ');
}

export function showInvalidInput(elem) {
  let inputs = Array.from(elem.querySelectorAll('.control__input'));
  let areas = Array.from(elem.querySelectorAll('.control__area'));
  const controls = inputs.concat(areas);
  controls
    .filter((control) => {
      return control.required === true;
    })
    .forEach((control) => {
      control.classList.add('control__input--valid');
    });
}

export function randomInteger(min, max) {
  let rand = min + Math.random() * (max + 1 - min);
  return Math.floor(rand);
}

export function debounce(cb) {
  var lastTimeout = null;

  return function () {
    var parameters = arguments;
    if (lastTimeout) {
      window.clearTimeout(lastTimeout);
    }
    lastTimeout = window.setTimeout(function () {
      cb.apply(null, parameters);
    }, DEBOUNCE_INTERVAL);
  };
}

export function start() {
  document.body.classList.add('preload');
}

export function end() {
  document.body.classList.remove('preload');
}

export function stringToHTML(str) {
  var dom = document.createElement('div');
  dom.innerHTML = str;
  return dom;
}


export function loadScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';

    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Ошибка загрузки скрипта ${script.src}`));

    document.body.append(script);
  });
}

export function isVisible(elem) {

  let coords = elem.getBoundingClientRect();
  let windowHeight = document.documentElement.clientHeight;

  let topVisible = coords.top > 0 && coords.top < windowHeight;
  let bottomVisible = coords.bottom < windowHeight && coords.bottom > 0;

  return topVisible || bottomVisible;
}

export function getResponseByMode(mockResponse, realResponse) {
  return document.body.dataset.mode === 'development' ? mockResponse : realResponse;
}

export function scrollById(id, offsetTop = 0) {
  const scrollTarget = document.querySelector(id);
  const topOffset = offsetTop;
  const elementPosition = scrollTarget.getBoundingClientRect().top;
  const offsetPosition = elementPosition - topOffset;

  window.scrollBy({
    top: offsetPosition,
    behavior: 'smooth'
  });
}

export function isNotHidden(elem) {
  return elem.offsetWidth > 0 || elem.offsetHeight > 0;
}

export function isError(data) {
  const errors = data.errors;
  if (errors.length > 0) {
    const error = errors[0];
    if ('message' in error) {
      throw error;
    } else {
      throw new Error('Неизвестная ошибка');
    }
  }
}

export function addAndRemoveAnimate(elem, time = 1500, cls = 'animate') {
  elem.classList.add(cls);

  setTimeout(() => {
    elem.classList.remove(cls);
  }, time);
}

export function checkPrivacy(form) {
  const privacy = form.querySelector('.privacy-js');

  if (privacy) {
    const input = privacy.querySelector('input');
    const label = privacy.querySelector('label');

    if (!input.checked) {
      addAndRemoveAnimate(label, 1200, 'control__label--shake');
      return false;
    }
  }

  return true;
}

export function addHandlerSubmitWithPrivacy(id) {
  const form = document.querySelector(id);

  if (form) {
    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      const status = checkPrivacy(form);

      if (status) {
        form.submit();
      }
    });
  }
}
